import axios from 'axios'

// const apikey = process.env.REACT_APP_API_KEY

let logoutCallback = null

export const setLogoutCallback = callback => {
  logoutCallback = callback
}

export const configureApi = token => {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  axios.defaults.headers.common['Content-Type'] = 'application/json'
  //   axios.defaults.headers.common['x-apikey'] = apikey
  //   axios.defaults.headers.common['api-key'] = apikey
}

// Response interceptor to handle expired/invalid session (401).
// Inside the app a 401 always means the session is no longer valid, so we
// force a logout regardless of the exact server message. (The backend returns
// { "msg": "Token has expired" }, but we intentionally do not match on the
// string — a trailing period or a different phrasing must not leave the user
// stuck logged-in with a dead token.)
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401 && logoutCallback) {
      logoutCallback()
    }
    return Promise.reject(error)
  },
)
